<h2 class="default-dialog-header font-weight-normal" mat-dialog-title>
	<span fxFlex> {{ dialogData.dialogTitle }} </span>
	<span fxFlex="10" fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog(null)" class="primary-light-color cursor-pointer">
			close
		</mat-icon>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content">
	<form (keydown.enter)="$event.preventDefault()" [formGroup]="moveToGroupForm" class="full-width">
		<div fxLayout="row" fxLayoutGap="1rem" class="m-t-1">
			<mat-form-field fxFlex="100">
				<mat-select formControlName="projectGroupId" placeholder="Select Group">
					<mat-option
						*ngFor="let projectGroup of dialogData.projectGroups"
						[value]="projectGroup.id"
					>
						{{ projectGroup.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</form>
</mat-dialog-content>
<mat-divider></mat-divider>

<mat-dialog-actions class="default-dialog-action">
	<div fxFlex="100" fxLayoutAlign="end end" fxLayoutGap="0.5rem">
		<span (click)="closeDialog(null)" class="link m-r-1">
			{{ dialogData.closeButtonText }}
		</span>
		<button (click)="submitForm()" color="primary" mat-raised-button>
			{{ dialogData.submitButtonText }}
		</button>
	</div>
</mat-dialog-actions>
